/* E-book duplicate guard (added Sep 26 2026).

   Stops a customer paying twice for the same download. Found in the orders:
   the 3-book set added on top of a 246 e-book already in the cart (#7806, #7880, #7953),
   and quantity 2 of one e-book (#7506, #7510, #7663).

   What it does, and nothing else:
     1. An e-book that is already inside a bundle in the cart is removed as a separate line.
     2. E-books and the all-digital 3-book set are capped at quantity 1, one line each.
   Physical products (paperbacks, shakers, kits, gift boxes) are never touched.

   Runs on page load and after every cart change: the theme's pubsub cartUpdate
   (product page adds) and the document 'cart:updated' event the drawer fires after it
   re-renders. Loaded once from layout/theme.liquid, same pattern as ecc-cart-extras.js,
   because scripts inside the drawer die when it re-renders via innerHTML.

   If a new bundle that contains an e-book is created, add its variant id to BUNDLE_EBOOKS. */
(function () {
  if (window.__ecCartGuard) return;
  window.__ecCartGuard = true;

  var EBOOK = {
    45340360245433: true, // 246 Viral Cocktail Recipes, E-book
    48591537143993: true, // 100 Classic Cocktails, E-book
    45619074269369: true  // Christmas Top 40, E-book
  };
  var BUNDLE_EBOOKS = {
    49073867391161: [45340360245433, 48591537143993, 45619074269369], // 3 Cocktail Books set
    49082109853881: [45340360245433]                                  // Whiskey Smoker Gift Box
  };
  var DIGITAL_BUNDLE = { 49073867391161: true };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var timer = null;

  function toast(msg) {
    return; // Sep 29 2026: message turned off on his request; the guard still fixes the cart silently.
    var t = document.getElementById('ec-guard-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ec-guard-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = 'position:fixed;left:50%;top:calc(env(safe-area-inset-top, 0px) + 84px);transform:translateX(-50%);pointer-events:none;' +
        'z-index:2147483647;background:#1f1f1f;color:#fff;padding:12px 18px;border-radius:10px;' +
        'font-family:inherit;font-size:14px;font-weight:500;line-height:1.4;text-align:center;' +
        'max-width:min(92vw,440px);box-shadow:0 6px 24px rgba(0,0,0,.25);transition:opacity .3s;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = '1';
    clearTimeout(t._hide);
    t._hide = setTimeout(function () { t.style.opacity = '0'; }, 4500);
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    // On /cart there is no drawer listening for cart:refresh, so reload to show the change.
    if (!document.querySelector('cart-drawer') && /\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inBundle = {};
        cart.items.forEach(function (it) {
          (BUNDLE_EBOOKS[it.variant_id] || []).forEach(function (v) { inBundle[v] = true; });
        });
        var updates = {};
        var seen = {};
        var removed = false;
        var capped = false;
        cart.items.forEach(function (it) {
          var v = it.variant_id;
          var digital = EBOOK[v] || DIGITAL_BUNDLE[v];
          if (!digital) return;
          if (EBOOK[v] && inBundle[v]) { updates[it.key] = 0; removed = true; return; }
          if (seen[v]) { updates[it.key] = 0; capped = true; return; }
          seen[v] = true;
          if (it.quantity > 1) { updates[it.key] = 1; capped = true; }
        });
        if (!removed && !capped) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) return;
          toast(removed
            ? 'That e-book is already in your bundle, so we removed the extra copy.'
            : 'E-books are one download each, so we set the quantity to 1.');
          refresh();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function soon() {
    clearTimeout(timer);
    timer = setTimeout(check, 350);
  }

  document.addEventListener('cart:updated', soon);

  function hookPubsub() {
    if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, soon);
      return true;
    }
    return false;
  }
  if (!hookPubsub()) document.addEventListener('DOMContentLoaded', hookPubsub);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon);
  else soon();
})();
